import { ComponentProps } from 'react';
import FavoritesButton from 'experiments/variants/GecpHeader/FavoritesButton';
import { FavouriteToggle as DefaultFavouriteToggle } from './favouriteToggle';
import { useSelector } from 'react-redux';
import { selectShouldUseGecpHeader } from 'store/appShell/selector';

type Props = ComponentProps<typeof DefaultFavouriteToggle>;

export const FavouriteToggle = (props: Props) => {
  const shouldUseGecpHeader = useSelector(selectShouldUseGecpHeader);

  if (shouldUseGecpHeader) {
    return <FavoritesButton {...props} gtmProduct={props.gtmProduct as never} />;
  }

  return <DefaultFavouriteToggle {...props} />;
};
